<template>
  <el-dialog title="设备工具箱配置" :visible.sync="dialogVisible" width="900px" :close-on-click-modal="false" @close="handleClose">
    <div class="toolbox-config-content">
      <!-- 第一行：工具箱号 -->
      <el-form ref="toolboxForm" :model="form" label-width="120px" size="small">
        <el-form-item label="工具箱号：" prop="toolboxNum">
          <el-select v-model="form.toolboxNum" filterable allow-create placeholder="请选择或输入工具箱号" style="width: 100%;" @change="handleToolboxChange">
            <el-option v-for="item in toolboxOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>

        <!-- 第二行：关联设备信息 -->
        <el-form-item label="关联设备信息：">
          <el-button type="primary" size="small" @click="openDeviceDialog">选择</el-button>
        </el-form-item>

        <!-- 第三行：设备列表 -->
        <el-form-item label="设备列表：">
          <el-table :data="deviceList" border style="width: 100%;" max-height="400" :header-cell-style="{ background: '#d8e8fb', textAlign: 'left', borderColor: '#CCC' }">
            <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
            <el-table-column prop="eqptName" label="设备名称" min-width="120" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="eqptNum" label="设备编号" min-width="180" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="eqptSituation" label="状态" min-width="100" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" width="80" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="removeDevice(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary" @click="handleSave">保 存</el-button>
    </div>

    <!-- 设备选择弹出层 -->
    <el-dialog title="选择设备" :visible.sync="deviceDialogVisible" width="800px" :close-on-click-modal="false" append-to-body>
      <div class="device-dialog-content">
        <!-- 搜索框 -->
        <div class="search-section" style="margin-bottom: 20px;">
          <el-input v-model="deviceSearchKeyword" placeholder="请输入设备名称或编号进行搜索" clearable @input="handleDeviceSearch" style="width: 300px;">
            <i slot="prefix" class="el-icon-search"></i>
          </el-input>
        </div>

        <!-- 设备列表 -->
        <div class="device-list-section">
          <el-table ref="deviceTable" :data="filteredDeviceOptions" @selection-change="handleDeviceSelectionChange" height="400" style="width: 100%">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="eqptName" label="设备名称" min-width="100"></el-table-column>
            <el-table-column prop="eqptNum" label="设备编号" min-width="260"></el-table-column>
          </el-table>
        </div>

        <!-- 已选设备统计 -->
        <div class="selected-count" style="margin-top: 15px; color: #606266;">
          已选择 {{ tempSelectedDevices.length }} 个设备
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelDeviceSelection">取 消</el-button>
        <el-button type="primary" @click="confirmDeviceSelection">确 定</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
// 引入API
import {
  queryEqptGuidAndName,
  queryToolboxEqptInfos,
  queryToolboxList,
  bindToolboxEquipment,
} from '@/api/contract/contract'

export default {
  name: 'ToolboxConfigDialog',
  data () {
    return {
      dialogVisible: false,
      deviceDialogVisible: false,

      // 表单数据
      form: {
        toolboxNum: '' // 工具箱号（业务唯一标识）
      },

      // 工具箱号选项
      toolboxOptions: [],

      // 设备列表（显示在表格中）
      deviceList: [],

      // 设备选择相关
      deviceSearchKeyword: '',
      allDeviceOptions: [], // 所有设备选项（从API获取）
      filteredDeviceOptions: [], // 过滤后的设备选项
      tempSelectedDevices: [] // 临时选择的设备
    }
  },

  methods: {
    /**
     * 打开对话框
     */
    openDialog () {
      this.dialogVisible = true
      this.loadToolboxOptions()
      this.loadAllDevices()
    },

    /**
     * 加载工具箱号选项
     * 调用API获取所有工具箱号列表
     */
    loadToolboxOptions () {
      queryToolboxEqptInfos().then(res => {
        if (res.retCode === 'ok') {
          const toolboxList = (res && res.additionalData) ? res.additionalData : []
          this.toolboxOptions = (Array.isArray(toolboxList) ? toolboxList : []).map(item => ({
            value: item.toolboxNum || item,
            label: item.toolboxNum || item
          }))
        } else {
          this.$message.error(res.retMsg || '获取工具箱号列表失败')
        }
      }).catch(error => {
        console.error('获取工具箱号列表失败:', error)
        this.$message.error('获取工具箱号列表失败')
      })
    },

    /**
     * 加载所有设备选项
     * 使用与 testing/index.vue 相同的 API
     */
    loadAllDevices () {
      // 调用API获取所有设备列表
      queryEqptGuidAndName({ eqptName: '' }).then(res => {
        if (res.retCode === 'ok') {
          const eqList = (res && res.additionalData) ? res.additionalData : []
          this.allDeviceOptions = (Array.isArray(eqList) ? eqList : []).map(i => ({
            eqptNum: i.eqptNum || i.code || '',
            eqptName: i.eqptName || i.name || i.label
          }))
          this.filteredDeviceOptions = [...this.allDeviceOptions]
        } else {
          this.$message.error(res.retMsg || '获取设备列表失败')
        }
      }).catch(error => {
        console.error('获取设备列表失败:', error)
        this.$message.error('获取设备列表失败')
      })
    },

    /**
     * 工具箱号变化事件
     * 根据工具箱号查询已绑定的设备
     */
    handleToolboxChange (value) {
      if (!value) {
        this.deviceList = []
        return
      }

      // 调用API查询该工具箱号已绑定的设备
      queryToolboxList(value).then(res => {
        if (res.retCode === 'ok') {
          const deviceList = (res && res.additionalData) ? res.additionalData : []
          this.deviceList = (Array.isArray(deviceList) ? deviceList : []).map(item => ({
            eqptNum: item.eqptNum || '',
            eqptName: item.eqptName || '',
            eqptSituation: item.eqptSituation || '',
            createTime: item.createTime || ''
          }))
        } else {
          // 如果查询失败或没有数据，清空设备列表（可能是新建的工具箱号）
          this.deviceList = []
        }
      }).catch(error => {
        console.error('查询工具箱设备失败:', error)
        // 查询失败时清空列表，允许用户继续操作
        this.deviceList = []
      })
    },

    /**
     * 打开设备选择弹窗
     */
    openDeviceDialog () {
      this.deviceDialogVisible = true
      this.deviceSearchKeyword = ''
      this.filteredDeviceOptions = [...this.allDeviceOptions]
      this.tempSelectedDevices = []

      // 等待DOM更新后设置表格选中状态
      this.$nextTick(() => {
        if (this.$refs.deviceTable) {
          this.$refs.deviceTable.clearSelection()

          // 将已在列表中的设备设置为选中状态
          this.deviceList.forEach(device => {
            const row = this.filteredDeviceOptions.find(option => option.eqptNum === device.eqptNum)
            if (row) {
              this.$refs.deviceTable.toggleRowSelection(row, true)
            }
          })
        }
      })
    },

    /**
     * 设备搜索
     */
    handleDeviceSearch () {
      const keyword = this.deviceSearchKeyword.toLowerCase()
      if (!keyword) {
        this.filteredDeviceOptions = [...this.allDeviceOptions]
      } else {
        this.filteredDeviceOptions = this.allDeviceOptions.filter(device =>
          (device.eqptName && device.eqptName.toLowerCase().includes(keyword)) ||
          (device.eqptNum && device.eqptNum.toLowerCase().includes(keyword))
        )
      }

      // 重新设置选中状态
      this.$nextTick(() => {
        if (this.$refs.deviceTable) {
          this.$refs.deviceTable.clearSelection()
          this.tempSelectedDevices.forEach(selectedDevice => {
            const row = this.filteredDeviceOptions.find(option => option.eqptNum === selectedDevice.eqptNum)
            if (row) {
              this.$refs.deviceTable.toggleRowSelection(row, true)
            }
          })
        }
      })
    },

    /**
     * 设备选择变化
     */
    handleDeviceSelectionChange (selection) {
      this.tempSelectedDevices = selection.map(device => ({
        eqptNum: device.eqptNum,
        eqptName: device.eqptName
      }))
    },

    /**
     * 确认设备选择
     */
    confirmDeviceSelection () {
      // 将选中的设备添加到设备列表中，使用设备编号去重
      this.tempSelectedDevices.forEach(device => {
        const exists = this.deviceList.some(item => item.eqptNum === device.eqptNum)
        if (!exists) {
          this.deviceList.push(device)
        }
      })

      this.deviceDialogVisible = false
      this.$message.success(`已添加 ${this.tempSelectedDevices.length} 个设备`)
    },

    /**
     * 取消设备选择
     */
    cancelDeviceSelection () {
      this.tempSelectedDevices = []
      this.deviceDialogVisible = false
    },

    /**
     * 删除设备
     */
    removeDevice (index) {
      this.$confirm('确定要删除该设备吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deviceList.splice(index, 1)
        this.$message.success('删除成功')
      }).catch(() => { })
    },

    /**
     * 保存
     * 调用API保存工具箱配置
     */
    handleSave () {
      // 验证
      if (!this.form.toolboxNum) {
        this.$message.warning('请输入或选择工具箱号')
        return
      }

      if (this.deviceList.length === 0) {
        this.$message.warning('请至少选择一个设备')
        return
      }

      // 构造API参数
      const params = {
        toolboxNum: this.form.toolboxNum,
        eqptNumList: this.deviceList.map(item => item.eqptNum)
      }

      // 调用API保存工具箱配置
      bindToolboxEquipment(params).then(res => {
        if (res.retCode === 'ok') {
          this.$message.success('保存成功')
          this.dialogVisible = false
          this.$emit('refresh')
          // 刷新工具箱号列表（可能新增了工具箱号）
          this.loadToolboxOptions()
        } else {
          this.$message.error(res.retMsg || '保存失败')
        }
      }).catch(error => {
        console.error('保存工具箱配置失败:', error)
        this.$message.error('保存失败：' + (error.message || '未知错误'))
      })
    },

    /**
     * 取消
     */
    handleCancel () {
      this.dialogVisible = false
      this.resetForm()
    },

    /**
     * 关闭对话框
     */
    handleClose () {
      this.resetForm()
    },

    /**
     * 重置表单
     */
    resetForm () {
      this.form = {
        toolboxNum: ''
      }
      this.deviceList = []
      this.deviceSearchKeyword = ''
      this.tempSelectedDevices = []
    }
  }
}
</script>

<style scoped>
.toolbox-config-content {
  padding: 10px 0;
}

.device-dialog-content {
  padding: 0 10px;
}

.search-section {
  display: flex;
  justify-content: flex-start;
}

.device-list-section {
  margin-top: 10px;
}

.selected-count {
  text-align: left;
  font-size: 14px;
}
</style>
